import { useCallback, useState } from 'react';
// import { CallBackProps } from 'react-joyride';

// Temporary types for React 19 compatibility
// TODO: Replace with types from a React 19 compatible tour library
interface CallBackProps {
  action: string;
  index: number;
  status: string;
  type: string;
}

export interface TourStep {
  target: string;
  content: string;
  title?: string;
  placement?: 'top' | 'bottom' | 'left' | 'right';
  disableBeacon?: boolean;
}

export const useTourGuide = () => {
  const [run, setRun] = useState(false);
  const [stepIndex, setStepIndex] = useState(0);

  const startTour = useCallback(() => {
    setRun(true);
    setStepIndex(0);
  }, []);

  const stopTour = useCallback(() => {
    setRun(false);
    setStepIndex(0);
  }, []);

  const resetTour = useCallback(() => {
    setRun(false);
    setStepIndex(0);
  }, []);

  const handleJoyrideCallback = useCallback((data: CallBackProps) => {
    const { action, index, status, type } = data;

    if (status === 'finished' || status === 'skipped') {
      stopTour();
    } else if (action === 'close') {
      stopTour();
    } else if (type === 'step:after' && action === 'prev') {
      setStepIndex(index - 1);
    } else if (type === 'step:after' && action === 'next') {
      setStepIndex(index + 1);
    }
  }, [stopTour]);

  return {
    run,
    stepIndex,
    startTour,
    stopTour,
    resetTour,
    handleJoyrideCallback,
  };
};
